import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Product } from '../../interfaces/product';
import { AnalyticsService } from '../../services/analytics.service';
import { CartDetailsService } from '../../services/cart-details.service';
import { CartService } from '../../services/cart.service';
import { DataLayerService } from '../../services/gtm-service/data-layer.service';
import { UtilsService } from '../../services/utils.service';
import { SharedModelComponent } from '../shared-model/shared-model.component';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss'
})
export class CartComponent {

  @Input('product') product!: Product
  environment: any = environment;
  cartObject: any = [];
  sub:Subscription=new Subscription()

  constructor(public utils: UtilsService,public dataLayerService:DataLayerService,public _decimalPipe: DecimalPipe, public service: CartService, private cartService: CartDetailsService, public dialog: MatDialog, private analyticsService: AnalyticsService) { }

  ngOnInit(): void {
    this.sub.add(  this.service.cartData$.subscribe(
      (data: any) => {
        this.cartObject = data ? data : []
        this.getProductQuantity()
      }))
  }

  getProductQuantity() {
    let cart: any = this.cartObject ? this.cartObject : []
    let found = cart.some((element: any) => this.product.inventoryGuId == element.inventoryGuId)
    if (found) {
      const index = cart.findIndex((element: any) => { return element.inventoryGuId == this.product.inventoryGuId })
      this.product.quantity = cart[index].quantity
    }
  }

  addToCart() {
    if ((window as any).fbq) {
      (window as any).fbq('track', 'AddToCart');
    } else {
    }
    let cart: any = this.cartObject ? this.cartObject : []
    let index:any;
    if (cart) {
      let found = cart.some((element: any) => this.product.inventoryGuId == element.inventoryGuId)
      if (found) {
         index = cart.findIndex((element: any) => { return element.inventoryGuId == this.product.inventoryGuId })
        if (cart[index].quantity < cart[index].maxQuantity && cart[index].quantity < cart[index].productInventoryCount) {
          cart[index].quantity++
          this.product.quantity = cart[index].quantity
          this.service.setInfo(cart, false)
          this.updateCart('add_to_cart',cart[index])
        }
        else {
          this.utils.openSnackBar(`You can buy only up to ${this.product.quantity} unit(s) of this product`, 'error-toster')
        }
      }
      else {
        this.product.quantity = 1
        cart.push(this.product)
      }
    }
    else if (!cart) {
      this.product.quantity = 1
      this.service.setInfo(this.product, false)
      this.updateCart('add_to_cart',cart[index])
    }
  }

  removeFromCart() {
    let cart: any = this.cartObject
    let index:any;
    if (cart) {
      let found = cart.some((element: any) => this.product.inventoryGuId == element.inventoryGuId)
      if (found) {
        index = cart.findIndex((element: any) => { return element.inventoryGuId == this.product.inventoryGuId })
        if (cart[index].quantity > 1) {
          cart[index].quantity--
          this.product.quantity = cart[index].quantity
          this.service.setInfo(cart, false)
          this.updateCart('remove_from_cart',cart[index])
        }
        else if (cart[index].quantity == 1) {
          const dialogRef = this.dialog.open(SharedModelComponent, {
            disableClose: true,
            panelClass: 'cookiesModel',
            data: {
              title: 'Delete Product',
              content: 'Are you sure, you want to delete this product ?',
              closeBtnText: "Cancel",
              confirmBtnText: "Delete",
              isConfirmation: true
            }
          });
          this.sub.add( dialogRef.afterClosed().subscribe((res: any) => {
            if (res) {
              if (cart.length > 1) {
                cart.splice(index, 1)
                this.service.setInfo(cart, false)
                this.updateCart('remove_from_cart',cart[index])

              }
              else if (cart.length == 1) {
                this.service.clearInfo()
                this.updateCart('remove_from_cart',cart[index])
              }
              this.product.quantity = 0
            }
          }));
        }
      }
    }

  }

  updateCart(type:any,data:any) {
    if (this.utils.getUser()) {
      this.sub.add(  this.cartService.checkout().subscribe((data: any) => {
        if (data.success) {
         this.dataLayerService.triggerAddRemoveEvent(type,data)

        }
        else if (!data.success) {
          this.utils.openSnackBar('Internal server error', 'error-toster')
        }
      }))
    }
    else {
      this.cartService.triggerCartUpdate();
     this.dataLayerService.triggerAddRemoveEvent(type,data)
    }
  }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }

}

